
import { computed } from 'vue';

export function useBaseIntl() {

	const ILANG_ATTR="intlLanguage";

	const languages = computed(() => {
		return window.Server.languages;
	});

	function changeLanguage(el: HTMLElement,lang: string): void {
		el.focus();
		sessionStorage.setItem(ILANG_ATTR,lang);
	}
	
	function initLanguage(): string {
		let lang: string = sessionStorage.getItem(ILANG_ATTR);
		if (!lang) {
			lang = window.Server.lang;
		}
		return lang;
	}
	
	return  { languages, changeLanguage, initLanguage };
}
